<template>
      <v-list  >
        <template >
          <v-list-item  v-for="item in lista" :key="item.codigo" @click="chamaAcao(item)" color="primary">
            <v-list-item-content class="tutorial">
              {{item.title}}
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
</template>
<script>
export default {
  props: {
    lista: Array,
  },
  mounted () {
  },
  methods: {
    chamaAcao(item){
      item.callback();
    },
    abreVideo(codigo, titulo){
      let paramModal = {
          codigo: codigo,
          title: titulo,
      }
      this.$store.commit('tutorial/abreVideo', paramModal, {root:true});
    },
  },
  data () {
    return {
    }
  },
}
</script>

<style>
.confirmMesgTxt {
  border-bottom: 1px solid #eee;
}
.v-list-item__content.tutorial {
  color: #118aca;
  font-family: sans-serif;
  font-weight: bold;
}


</style>
